import getIsOpen from './is-open';
import getDisplayMode from './display-mode';
import getPanelWidth from './panel-width';
import getHostState from './host-state';

export default {
  getIsOpen,
  getDisplayMode,
  getPanelWidth,
  getHostState,
};
